export const environment = {
    production: false,
    enableTN: true,
    enableEncoding: false,
    enableEncryption: true,
    isDev : true,

    formActionUrl: 'https://stg.nesl.co.in/DDE_IU_Registration_V3/IUREG',

    oatrization: 'Basic VUJJS0NDOnpyazV0MFVR',
    respUrl: 'https://kccnewuat.unionbankofindia.bank.in/DES_WL/DDE/responsewl',

    bypass:{
      BYPASS_CONSENT_FORM : true
    },

    congratsUrlSubDom:"kccnewuat",
    envUrl:"dev",

    // irtcUrl:'https://kccnewuat.unionbankofindia.bank.in/v1/etnb',
    // keyExchange:"https://kccnewuat.unionbankofindia.bank.in/v1",
    // mpNodeUrl:'https://kccnewuat.unionbankofindia.bank.in/v1/etnb',
    // mpWebHookUrl:'https://kccnewuat.unionbankofindia.bank.in',
    // apiBaseUrl: 'https://kccnewuat.unionbankofindia.bank.in/v1/etnb/ekyc',  //LOCAL TESTING
    // nodeUrl: 'https://kccnewuat.unionbankofindia.bank.in/v1/etnb',
    // satSureBaseUrl: 'https://kccnewuat.unionbankofindia.bank.in/',

    // irtcUrl:'http://3.7.233.228:8081/v1/etnb',
    // keyExchange:"http://3.7.233.228:8081/v1",
    // mpNodeUrl:'http://3.7.233.228:8081/v1/etnb',
    // mpWebHookUrl:'http://3.7.233.228:8081',
    // apiBaseUrl: 'http://3.7.233.228:8081/v1/etnb/ekyc',//LOCAL TESTING
    // nodeUrl: 'http://3.7.233.228:8081/v1/etnb',
    // satSureBaseUrl: 'http://3.7.233.228:8081/',

    //   irtcUrl:'http://3.7.233.228:8100/v1/etnb',
    // keyExchange:"http://3.7.233.228:8100/v1",
    // mpNodeUrl:'http://3.7.233.228:8100/v1/etnb',
    // mpWebHookUrl:'http://3.7.233.228:8100',
    // apiBaseUrl: 'http://3.7.233.228:8100/v1/etnb/ekyc',//LOCAL TESTING
    // nodeUrl: 'http://3.7.233.228:8100/v1/etnb',
    // satSureBaseUrl: 'http://3.7.233.228:8100/',

    irtcUrl:'https://mockserver.whatsloan.com/v1/etnb',
    keyExchange:"https://mockserver.whatsloan.com/v1",
    mpNodeUrl:'https://mockserver.whatsloan.com/v1/etnb',
    mpWebHookUrl:'https://mockserver.whatsloan.com',
    apiBaseUrl: 'https://mockserver.whatsloan.com/v1/etnb/ekyc', // MOCK SERVER TESTING
    nodeUrl: 'https://mockserver.whatsloan.com/v1/etnb',
    satSureBaseUrl: 'https://mockserver.whatsloan.com/',

    // irtcUrl:'https://mockserver.whatsloan.com/v1/etnb',
    // keyExchange:"https://mockserver.whatsloan.com/v1",
    // mpNodeUrl:'https://mockserver.whatsloan.com/v1/etnb',
    // mpWebHookUrl:'https://mockserver.whatsloan.com',
    // apiBaseUrl: 'https://mockserver.whatsloan.com/v1/etnb/ekyc', // MOCK SERVER TESTING
    // nodeUrl: 'https://mockserver.whatsloan.com/v1/etnb',
    // satSureBaseUrl: 'https://mockserver.whatsloan.com/',

    // irtcUrl:'http://192.168.1.20:8081/v1/etnb',
    // mpNodeUrl:'http://192.168.1.20:8081/v1/etnb',
    // mpWebHookUrl:'http://192.168.1.20:8081',
    // apiBaseUrl: 'http://192.168.1.20:8081/v1/etnb/ekyc',  //LOCAL TESTING
    // nodeUrl: 'http://192.168.1.20:8081/v1/etnb',
    // satSureBaseUrl: 'http://192.168.1.20:8081/',

    // irtcUrl:'https://kccnew.unionbankofindia.bank.in/v1/etnb',-
    // mpNodeUrl:'https://kccnew.unionbankofindia.bank.in/v1/etnb',
    // mpWebHookUrl:'https://kccnew.unionbankofindia.bank.in',
    // apiBaseUrl: 'https://kccnew.unionbankofindia.bank.in/v1/etnb/ekyc',  //LOCAL TESTING
    // nodeUrl: 'https://kccnew.unionbankofindia.bank.in/v1/etnb',
    // satSureBaseUrl: 'https://kccnew.unionbankofindia.bank.in/',
    // congratsUrlSubDom:"kccnew",

    docUrl:'https://api-ubi.whatsloanfintech.com',

     serverType: 'UAT',
     shareKey:"MKPzluxXq066hkatRNIFDc7CKJOBMdAi",

  
    // ── Consent Management (Leegality Consentin via Union Bank APIM) ──────────
    // Frontend loads the Web SDK + runs the consent popup; token/register/check
    // are handled by the backend (existing webhook layer). See consent.service.ts.
    consent: {
      enabled: true,                                               // master switch (false = bypass consent -> straight to land)
      sdkUrl: "https://sdk.consent.in/consent-collect-sdk.min.js",  // TODO(bank): confirm SDK CDN URL
      sdkGlobal: "LeegalityConsentCollector",                       // TODO(bank): confirm window global (LeegalityConsentCollector | ConsentCollector)
    },

    someRandomString: {
      alpha: 'ghTTGIUhu8uy785t78Y796tb7y79HY9H79b587ec46wx69mu90N80V',
      beta: 'Th6gF9jAM1xo30neA02Hj6RSyut76UHKhiuYGUKHUiyi77TG7IGUI',
    },

    placeHolderSetting : {
      placeholder:"Customer ID",
      demo : "",
      laasName : "UBI LaaS"
    },
    urlSetting : {
      url : 'http://localhost:4200/',
    },

    disableInput : false,
  };
  